// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"276":"899c8473","360":"24ff20ac"}[chunkId] + ".css";
};